
export enum BranchType {
  FRANCHISE= 'franchise',
  OWN = 'own',
  CERTIFIED = 'certified',
}
